export default __webpack_public_path__ + "static/media/018-r.df20af97.svg";